import React from "react";
import "./Home.css";
import { Colors } from "../../consts/Colors";
import Subtitle from "../../components/Subtitle";
import Title from "../../components/Title";

const TitleLink = ({ title, url }) => {
  return (
    <div
      className="company-link"
      style={{
        fontWeight: "bold",
        fontSize: "1.5rem",
        margin: "1rem",
        padding: "0px",
      }}
      onClick={() => window.open(url, "_blank", "noopener")}
    >
      {title}
    </div>
  );
};

const COMPANIES = [
  {
    url: "https://medbikri.com/",
    logo_url: "https://logo.clearbit.com/medbikri.com",
    name: "Medbikri",
    start: "Apr 2022",
    end: "Dec 2023",
    duration: "(1 yr, 8 m)",
    title: "SDE",
    description:
      "• Worked on ReactJs & React Native App - and some internal apps using various other technologies \n • Development, TDD, Performance Profiling, Analytics. Involved in core features, architectural rewrites, and other crucial decisions.• Handled 3rd party product integration.",
  },
  {
    url: "https://www.havishmconsulting.com/",
    logo_url: "https://logo.clearbit.com/havishmconsulting.com",
    name: "Havish M Consulting",
    start: "Jan 2022",
    end: "Mar 2022",
    duration: "(3 months)",
    title: "ReactJS Developer Intern",
    description:
      "• Developed Excel Add-ins (web apps) using TypeScript.\n • Developed and pitched a Talent Tracker AddIn in ReactJs/Typescript.\n • The product we made is currently being used by 2 big firms in production.",
  },
  {
    url: "https://www.havishmconsulting.com/",
    logo_url: "https://logo.clearbit.com/havishmconsulting.com",
    name: "Havish M Consulting",
    start: "Feb 2021",
    end: "Apr 2021",
    duration: "(2 months)",
    title: "ReactJS Developer Intern",
    description:
      "• Created a series of Microsoft Office Excel Web Add-Ins for the company using JavaScript/TypeScript.",
  },
];

const WorkExpItem = ({ company }) => {
  return (
    <div
      style={{
        display: "flex",
        width: "800px",
        borderRadius: "12px",
        margin: "1rem",
      }}
    >
      <div
        style={{
          backgroundColor: Colors.floatBg,
          borderRadius: "12px 0 0 12px",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          padding: "1rem",
          borderRight: `1px solid ${Colors.border}`,
          flexDirection: "column",
          minWidth: "250px",
        }}
      >
        <img
          src={company.logo_url}
          alt={company.name}
          width="24px"
          height="24px"
          style={{ width: "50px", height: "50px", borderRadius: "12px" }}
        />
        <TitleLink url={company.url} title={company.name} />
        <Subtitle>{company.start}</Subtitle>
        To
        <Subtitle>{company.end}</Subtitle>
        <Subtitle>{company.duration}</Subtitle>
      </div>
      <div
        style={{
          backgroundColor: Colors.floatBg,
          borderRadius: "0 12px 12px 0",
          justifyContent: "center",
          padding: "1rem",
        }}
      >
        <Title>{company.title}</Title>
        <br />
        <br />
        <Subtitle>{company.description}</Subtitle>
        <br />
      </div>
    </div>
  );
};

const WorkExp = () => {
  return (
    <div>
      {COMPANIES.map((com) => {
        return <WorkExpItem company={com} />;
      })}
    </div>
  );
};

export default WorkExp;
